import { TenderBetDTO } from '../../../../Domain/DTO/TenderBetDTO';

export class TenderBetExtendedDTO extends TenderBetDTO {
    MaxBetValue: number;
    MinBetValue: number;
}